import { createSlice } from '@reduxjs/toolkit';

const positionsSlice = createSlice({
  name: 'positions',
  initialState: {
    positions: [],
  },
  reducers: {
    addPosition: (state, action) => {
      state.positions.push(action.payload);
    },
    setPositions: (state, action) => {
      state.positions = action.payload;
    },
    clearPositions: (state) => {
      state.positions = [];
    },
    removePosition: (state, action) => {
      state.positions = state.positions.filter(pos => pos.orderId !== action.payload);
    },
  },
});

export const { addPosition, setPositions, clearPositions, removePosition } = positionsSlice.actions;
export const selectAllPositions = (state) => state.positions.positions;
export default positionsSlice.reducer;
